var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("collapse", { attrs: { title: "Cantidad a Pagar" } }, [
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _vm._l(_vm.visibleItems, function(item, idx) {
          return _c(
            "div",
            { key: item.id || idx, staticClass: "mb-3" },
            [
              _c(
                "custom-callout",
                {
                  staticClass: "mb-4 custom-callout contracts-box",
                  attrs: { "border-color": "#b5c3bc", "has-toggle": false }
                },
                [
                  _c("div", { staticClass: "row pt-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-md-3 d-flex flex-column my-2"
                      },
                      [
                        _c("span", { staticClass: "color-gray-6 font-14" }, [
                          _vm._v("Proveedor")
                        ]),
                        _c(
                          "span",
                          { staticClass: "font-16 font-weight-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("empty")(item.providerName)) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    !_vm.isRenewal
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 d-flex flex-column my-2"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 font-14" },
                              [_vm._v("Número de Contrato")]
                            ),
                            _c(
                              "span",
                              { staticClass: "font-16 font-weight-bold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(item.contractNumber)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    !_vm.isRenewal
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 d-flex flex-column my-2"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 font-14" },
                              [_vm._v(" Cuantía del Contrato Vigente ")]
                            ),
                            _c(
                              "span",
                              { staticClass: "font-16 font-weight-bold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("price")(item.amount)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    !_vm.isRenewal
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 d-flex flex-column my-2"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 font-14" },
                              [_vm._v("Enmiendas Otorgadas")]
                            ),
                            _c(
                              "span",
                              { staticClass: "font-16 font-weight-bold" },
                              [_vm._v(_vm._s(item.quantity))]
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    !_vm.isRenewal && !_vm.isAmendment
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 d-flex flex-column my-2"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 font-14" },
                              [_vm._v("Enmienda")]
                            ),
                            _c(
                              "span",
                              { staticClass: "font-16 font-weight-bold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(item.lastAmendmentCode)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-md-3 d-flex flex-column my-2"
                      },
                      [
                        _c("span", { staticClass: "color-gray-6 font-14" }, [
                          _vm._v("Monto Asignado")
                        ]),
                        !_vm.isReadOnly
                          ? [
                              _vm.isAmountRequired
                                ? _c("validation-provider", {
                                    attrs: {
                                      rules: "required|greaterThanZero"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c(
                                                "money",
                                                _vm._b(
                                                  {
                                                    staticClass: "form-control",
                                                    class: {
                                                      "was-Invalidated":
                                                        errors[0]
                                                    },
                                                    model: {
                                                      value: item.paymentAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "paymentAmount",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "item.paymentAmount"
                                                    }
                                                  },
                                                  "money",
                                                  _vm.moneyOptions,
                                                  false
                                                )
                                              ),
                                              errors[0]
                                                ? _c("error", {
                                                    attrs: {
                                                      message: errors[0],
                                                      variant: "no-border"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                : _c(
                                    "money",
                                    _vm._b(
                                      {
                                        staticClass: "form-control",
                                        model: {
                                          value: item.paymentAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "paymentAmount",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.paymentAmount"
                                        }
                                      },
                                      "money",
                                      _vm.moneyOptions,
                                      false
                                    )
                                  )
                            ]
                          : [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("price")(item.paymentAmount)
                                    ) +
                                    " "
                                )
                              ])
                            ]
                      ],
                      2
                    ),
                    !_vm.isRenewal
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 d-flex flex-column my-2 d-flex"
                          },
                          [
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _c(
                                "span",
                                { staticClass: "color-gray-6 font-14" },
                                [_vm._v("Total del Contrato")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "font-16 font-weight-bold text-success"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(
                                          item.amount + item.paymentAmount
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          )
        }),
        _vm.showToggle
          ? _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(
                  "action-button",
                  {
                    attrs: {
                      variant:
                        "outline-success custom-view-more actionButton rounded-pill"
                    },
                    on: {
                      click: function($event) {
                        _vm.expanded = !_vm.expanded
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.expanded ? "Ver menos" : "Ver más") + " "
                    ),
                    _c("i", {
                      staticClass: "ml-1",
                      class: _vm.expanded
                        ? "fas fa-chevron-up"
                        : "fas fa-chevron-down"
                    })
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }